
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/migration-guide/updating-downstream-applications",
      function () {
        return require("private-next-pages/events/migration-guide/updating-downstream-applications.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/migration-guide/updating-downstream-applications"])
      });
    }
  